export default "__VITE_ASSET__CwRpnIML__"